module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN214_146108670.e910192d.png";